export default "__VITE_ASSET__OADxyk2j__"